// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"233":"6d8257805e06699b","8641":"e471743885406195"}[chunkId] + ".js";
};